import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function OutsourcingCreateMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.drc.examinationResult.list);
  };

  return (
    <MainMenuItem
      itemTitleString="検査結果を見る"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default OutsourcingCreateMenuItem;
